import { CodigoTipoEntrega } from "app/types/CodigoTipoEntrega";
import { IItemOrcamento } from "app/types/IItemOrcamento";

export type DadosParaAvaliarExibicaoModalVendaSobEncomenda = {
    VendaSobEncomenda: boolean
    CodigoTipoEntrega: CodigoTipoEntrega
    CodigoFilialRetirada: string
    Quantidade: number
}

export const ehNecessarioMostrarModalVendaSobEncomenda = ({dadosItemAtual, dadosItemAnterior}:{dadosItemAtual: DadosParaAvaliarExibicaoModalVendaSobEncomenda, dadosItemAnterior: DadosParaAvaliarExibicaoModalVendaSobEncomenda}) => {
    return  dadosItemAtual.VendaSobEncomenda && (
            dadosItemAnterior.CodigoTipoEntrega != dadosItemAtual.CodigoTipoEntrega ||
            dadosItemAnterior.CodigoFilialRetirada != dadosItemAtual.CodigoFilialRetirada ||
            dadosItemAnterior.Quantidade != dadosItemAtual.Quantidade)
}